export { default } from "@projectaltair/web-ui-shared-components/lib/components/atoms/button";
